import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'upper_management_does_not_recognize_accept_safety_committee'

export const dataPointDefinition = {
  retracedId: 'upper_management_does_not_recognize_accept_safety_committee',
  name: 'Upper management does not recognize/ accept the safety committee',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-hsc-16x',
      number: 'HS-HSC-9-6',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-hsc-10',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-hsc-1;hs-17,Yes',
      machineShowHide: '[2],hs-hsc-1;hs-17,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-hsc-16x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31380,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
